export default __webpack_public_path__ + "static/media/Jessica_Kupferman_AHV_In_Moms_We_Trust.e7b3ff3e.jpg";